import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, Clock, Coins, MapPin } from "lucide-react";
import Footer from "../components/Footer";
import SafeImage from "../components/SafeImage";
import BookmarkHeart from "../components/BookmarkHeart";

export default function FeaturedRoutesPage() {
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    api.get("/featured-routes").then((r) => setRoutes(r.data));
  }, []);

  return (
    <div data-testid="featured-routes-page" className="pt-safe-navbar-lg pb-16">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="mb-10">
          <div className="iq-overline mb-2">Hand-curated</div>
          <h1 className="font-display text-cream text-5xl md:text-6xl tracking-wider">Tours of the continent</h1>
          <p className="font-serif italic text-cream-dim text-lg mt-3 max-w-2xl">
            Eight grand journeys, each crafted by rail romantics. Pick one as your spine — then bend it to your whim.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {routes.map((r, i) => (
            <Link
              key={r.slug}
              to={`/routes/${r.slug}`}
              data-testid={`featured-route-${r.slug}`}
              className="group iq-card overflow-hidden flex flex-col animate-fade-up hover:border-gold/40 transition-colors"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <SafeImage src={r.hero} alt={r.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/40 to-transparent" />
                <div className="absolute top-3 left-3 bg-gold/90 text-ink text-[10px] font-display tracking-widest px-2 py-1 rounded-sm">{r.vibe}</div>
                <div className="absolute top-3 right-3">
                  <BookmarkHeart kind="tour" slug={r.slug} label={r.name} />
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-display text-cream text-3xl md:text-4xl tracking-wider leading-none">{r.name}</h3>
                  <p className="font-serif italic text-cream-dim mt-1">{r.tagline}</p>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <p className="text-cream-dim text-sm leading-relaxed line-clamp-2">{r.description}</p>
                <div className="flex items-center justify-between mt-4 flex-wrap gap-3">
                  <div className="flex items-center gap-4 text-xs text-cream-dim/80">
                    <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-gold" /> {r.duration_days} days</span>
                    <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-gold" /> {r.cities.length} cities</span>
                    <span className="inline-flex items-center gap-1"><Coins className="h-3.5 w-3.5 text-gold" /> from €{r.est_price_eur}</span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-gold font-display tracking-widest text-sm group-hover:gap-2 transition-all">
                    Explore <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
